import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import AddEditRoleModal from "./addEditRoleModal";
import BSPagination from "../../Components/pagination";
import LoadingSpinner from "../../Components/spinner";
import {
  deleteRoleById,
  fetchRolesList,
  searchRoles,
  toggleRoletatus,
} from "../../services/axios/apiManager";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const RolesList = ({ roles, setRoles, pagination, setPagination, granted }) => {
  const tableRef = useRef(null);
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState({});
  const [filtering, setFiltering] = useState(false);
  const [filters, setFilters] = useState(4);

  const fetchRoles = async (pgntn, str = "") => {
    setFiltering(true);
    const response = await fetchRolesList(
      pgntn.currentPage,
      pgntn.pageSize,
      str
    );
    if (response?.data?.data) {
      setRoles(response.data.data);
    }
    if (response?.data?.pagination) {
      setPagination(response.data.pagination);
    }
    setFiltering(false);
  };
  // // // status = 0-Inactive, 1-Active, 2-deleted, 3 default
  const fetchFilteredRoles = async (e) => {
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchRoles(pagination, string);
  };
  // // // Search
  const handleSearch = async (e) => {
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      const results = await searchRoles(string);
      if (results?.data?.data) {
        setRoles(results.data.data);
      }
    } else {
      await fetchRoles(pagination);
    }
  };
  const resetFilters = async () => {
    setFilters(3);
    setQuery("");
    await fetchRoles(pagination);
  };
  // // // Open Add Edit Role
  const handleOpenAddEditModal = (role) => {
    setSelectedRole(role);
    setShowModal(true);
  };

  // // // Change status Logic
  const handleStatusChange = async (role) => {
    if (!granted?.some((g) => g.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        }
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of role "${role.name}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: role.id, status: role.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const response = await toggleRoletatus(data);
    if (response?.data?.success === true) {
      await fetchRoles(pagination);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    fetchRoles(temp);
  };

  // // // Delete Role logic
  const handleDeleteRole = (role) => {
    setModalOptions({
      header: "Delete Role",
      body: `Are you sure you want to delete role "${role.name}"?`,
      okay: "Delete",
      method: deleteRole,
      data: { id: role.id },
    });
    setShowOptionsModal(true);
  };

  const deleteRole = async (data) => {
    if (data.id) {
      const response = await deleteRoleById(data.id);
      if (response?.data?.success && response?.data?.data === 1) {
        await fetchRoles(pagination);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = roles.map((role) => {
      let statusBtn = "";

      statusBtn = `
        <button class="btn btn-sm status-btn ${role.status === 1 ? "text-success" : "text-danger"}" data-id="${role.id}" title="change status">
          ${role.status === 1 ? "Active" : "Inactive"}
        </button>
      `;

      let actions = "";
      if (granted?.some((g) => g.type === "update")) {
        actions += `
          <button class="btn btn-sm btn-outline-primary edit-btn me-1" data-id="${role.id}" title="Edit">
            <i class="fas fa-edit"></i>
          </button>
        `;
      }
      if (!role?.is_associated && granted?.some((g) => g.type === "delete")) {
        actions += `
          <button class="btn btn-sm btn-outline-danger delete-btn" data-id="${role.id}" title="Delete">
            <i class="fas fa-trash-alt"></i>
          </button>
        `;
      }
      return [role.id, role.name.toUpperCase(), statusBtn, actions];
    });

    const config = {
      data: rows,
      columns: [
        { title: "ID", className: "text-start" },
        { title: "Role Name" },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }

    $table.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const role = roles.find((r) => r.id === id);
      handleStatusChange(role);
    });
    $table.off("click", ".edit-btn").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      const role = roles.find((r) => r.id === id);
      setSelectedRole(role);
      setShowModal(true);
    });
    $table.off("click", ".delete-btn").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const role = roles.find((r) => r.id === id);
      handleDeleteRole(role);
    });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [roles, granted]);

  return (
    <div className="container py-4 text-light bg-dark rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-8 row">
          <div className="col-md-5">
            <Form.Control
              type="text"
              placeholder="Search Roles..."
              value={query}
              onChange={(e) => {
                handleSearch(e);
              }}
              className="bg-dark text-light border-light input-placeholder-light"
            />
          </div>
          <div className="col-md-5">
            <Form.Select
              name="status"
              value={filters}
              onChange={(e) => {
                fetchFilteredRoles(e);
              }}
              className="bg-dark border-light text-light"
            >
              <option value="3">Active & Inactive</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
              <option className="text-danger" value="2">
                Deleted
              </option>
            </Form.Select>
          </div>
          <div className="col-md-2">
            {filtering ? (
              <LoadingSpinner size={"md"} />
            ) : (
              <div className="row ">
                <Button
                  title="Reset Filters And Rrfresh Records"
                  className="btn btn-success"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  Reset
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-4 text-end">
          {granted.some((g) => g.type === "create") && (
            <Button
              title="Add New Role"
              className="btn btn-success"
              onClick={() => {
                handleOpenAddEditModal({});
              }}
            >
              <i className="bi bi-plus-circle"></i> Add Role
            </Button>
          )}
        </div>
      </div>

      <div className="table-responsive">
        <div className="table-responsive">
          <table
            ref={tableRef}
            className="table table-dark table-striped w-100"
          />
        </div>

        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
      </div>
      <AddEditRoleModal
        setSelectedRole={setSelectedRole}
        selectedRole={selectedRole}
        setShowModal={setShowModal}
        showModal={showModal}
        setRoles={setRoles}
      />
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RolesList;
